import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  GetAllParentCategories,
  DeleteParentCategoryById,
  AddParentCategoryApi,
  EditParentCategoryApi,
  GetParentCategoryById,
  AddImage,
  RemoveImage,
} from "../../api";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import Select from "react-select";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import default_prod2 from "../../data/default_prod2.png";
import "../../styles/AddProduct.css";
import imageCompression from "browser-image-compression";
import { validateName, ValidText } from "../../contexts/Utils";

const AddEditParentCategory = () => {
  const navigate = useNavigate();
  const { currentColor, defaultImageMode, userID, userToken } =
    useStateContext();
  const location = useLocation();
  const { fromPage } = location.state || {};
  const [brand, setBrand] = useState("");
  const [brandInfo, setBrandInfo] = useState(null);
  const [getbrands, setBrands] = useState([]);
  const [brandOptions, setbrandOptions] = useState([]);
  const [brand_id, setbrand_id] = useState("");
  const [name, setName] = useState("");
  const [featrd, setFeatrd] = useState(0);
  const [note, setNote] = useState("");
  const [ValError, setValError] = useState([]);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [ProductImage, setProductImage] = useState("");
  const [ProductImage1, setProductImage1] = useState(null);
  const fileInputRef = useRef(null);
  //   //dataURLtoFile(default_img, "default_img.jpg")
  //   null
  // );
  const [mode, setMode] = useState("Add");
  const [loadBtn, setLoadBtn] = useState(false);

  const ValidText1 = (txt, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (txt.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (ValidText(txt)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const validName1 = (name, ii) => {
    try {
      const updatedErrors = [...ValError];
      if (name.trim().length === 0) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return false;
      }
      if (validateName(name)) {
        updatedErrors[ii] = "";
        setValError(updatedErrors);
        return true;
      }
      updatedErrors[ii] = "Invalid field!";
      setValError(updatedErrors);
      return false;
    } catch (err) {
      return false;
    }
  };

  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const handleChangeNote = (e) => {
    setNote(e.target.value);
  };

  const handleChangFeatrd = (e) => {
    setFeatrd((prev) => (prev === 0 ? 1 : 0));
  };

  const handleAddMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      setMode("Add");
      setBrand("");
      setBrandInfo(null);
      setbrand_id("");
      setName("");
      setNote("");
      setProductImage("");
      setProductImage1(null);
      setFeatrd(0);
      // setprofile(null);
      setUploadedImage(null);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      setMode("Edit");
      setBrand("");
      setBrandInfo(null);
      setbrand_id("");
      setName("");
      setNote("");
      setProductImage("");
      setProductImage1(null);
      setFeatrd(0);
      // setprofile(null);
      setUploadedImage(null);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDeleteMode = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      setMode("Delete");
      setBrand("");
      setBrandInfo(null);
      setbrand_id("");
      setName("");
      setNote("");
      setProductImage("");
      setProductImage1(null);
      setFeatrd(0);
      // setprofile(null);
      setUploadedImage(null);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      navigate("/Product/AddEditCategory", {
        state: { fromPage: "ParentCategory" },
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddSubmit = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    var resp = 0;

    try {
      setValError([]);
      const updatedErrors = [...ValError];

      if (
        (mode === "Edit" || mode === "Delete") &&
        (!brand_id || brand_id === "")
      ) {
        updatedErrors[0] = "Select a Parent Category!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";

      if (name === "") {
        updatedErrors[1] = "Please enter name!";
        setValError(updatedErrors);
        return;
      }
      if (name) {
        if (validName1(name, 1) === false) {
          return;
        }
      }
      updatedErrors[1] = "";
      if (note !== "") {
        if (ValidText1(note, 2) === false) {
          return;
        }
      }
      updatedErrors[2] = "";
      setValError(updatedErrors);

      if (mode === "Add") {
        if (window.confirm("Do you want to add Parent Category?")) {
          var fk1 = "",
            pu1 = "",
            iu1 = "",
            cu1 = "",
            ou1 = "";
          if (ProductImage) {
            const options = {
              maxSizeMB: 0.1, // Maximum file size in MB
              maxWidthOrHeight: 2000, // Maximum width or height of the image
              useWebWorker: true, // Use web worker for faster compression
              fileType: "image/webp", // ✅ Convert to WebP
            };
            var z = await imageCompression(ProductImage, options);

            var f_name = name
              .substring(0, Math.min(50, name.length))
              .split(" ")
              .join("_");
            const response1 = await AddImage(
              f_name,
              "PARENTCATEGORY",
              z,
              userID,
              userToken
            );
            const data1 = await response1.data;
            if (data1.imageUrl) {
              fk1 = data1.fileKey;
              pu1 = data1.publicUrl;
              iu1 = data1.imageUrl;
              cu1 = data1.cdnUrl;
              ou1 = "";
            }
          }
          const res = await AddParentCategoryApi(
            name,
            note,
            featrd,
            null, //z,
            fk1,
            pu1,
            iu1,
            cu1,
            ou1,
            userID,
            userToken
          );
          resp = res.status;
          if (resp === 200) {
            alert("Added successfully.");
          } else {
            alert("Fail to add Parent Category.");
          }
        }
      } else if (mode === "Edit") {
        if (window.confirm("Do you want to edit this Parent Category?")) {
          var fk = brandInfo.file_key || "",
            pu = brandInfo.public_url || "",
            iu = brandInfo.private_url || "",
            cu = brandInfo.cdn_url || "",
            ou = brandInfo.other_url || "";

          if (ProductImage === null && ProductImage1 === null) {
            await RemoveImage(brandInfo.file_key, userID, userToken);

            fk = "";
            pu = "";
            iu = "";
            cu = "";
            ou = "";
          } else if (ProductImage !== null && ProductImage1 === null) {
            if (brandInfo.file_key) {
              await RemoveImage(brandInfo.file_key, userID, userToken);
            }

            const options = {
              maxSizeMB: 0.1, // Maximum file size in MB
              maxWidthOrHeight: 2000, // Maximum width or height of the image
              useWebWorker: true, // Use web worker for faster compression
              fileType: "image/webp", // ✅ Convert to WebP
            };
            var z1 = await imageCompression(ProductImage, options);

            var f_name1 = name
              .substring(0, Math.min(50, name.length))
              .split(" ")
              .join("_");
            const response1 = await AddImage(
              f_name1,
              "PARENTCATEGORY",
              z1,
              userID,
              userToken
            );
            const data1 = await response1.data;
            if (data1.imageUrl) {
              fk = data1.fileKey;
              pu = data1.publicUrl;
              iu = data1.imageUrl;
              cu = data1.cdnUrl;
              ou = "";
            }
          }
          const res = await EditParentCategoryApi(
            brand_id,
            name,
            note,
            featrd,
            null, //z,
            fk,
            pu,
            iu,
            cu,
            ou,
            userID,
            userToken
          );
          resp = res.status;
          if (resp === 200) {
            alert("Updated successfully.");
          } else {
            alert("Fail to edit Parent Category!");
          }
        }
      } else if (mode === "Delete") {
        if (brand_id === 700 || brand_id === "700") {
          alert("This Parent Category cannot be removed!");
          return;
        }
        if (
          window.confirm(
            `Do you want to remove ${brand.label} Parent Category?`
          )
        ) {
          const res = await DeleteParentCategoryById(
            brand_id,
            userID,
            userToken
          );
          resp = res.status;
          if (resp === 200) {
            await RemoveImage(brandInfo.file_key, userID, userToken);
            alert("Removed successfully.");
          } else {
            alert("Fail to remove Parent Category!");
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoadBtn(false);
      if (resp === 200) {
        navigate("/Product/AddEditParentCategory", {
          state: { fromPage: fromPage },
        });
        window.location.reload();
      }
    }
  };

  const handleImageChange = (e) => {
    try {
      setProductImage1(null);
      //setFlag(1);
      const file = e.target.files[0];
      if (!file) {
        //setProductImage(default_prod2);
        setProductImage(null);
        // setprofile(null);
        setUploadedImage(null);
      } else {
        if (file.size > 4194304) {
          alert("Image File max size is 4 MB!");
          setProductImage(null);
          setUploadedImage(null);
          // setprofile(null);
          e.target.value = null;
          return;
        } else {
          // setprofile(file);
          setProductImage(file);
          const reader = new FileReader();
          reader.onloadend = () => {
            setUploadedImage(reader.result);
          };
          reader.readAsDataURL(file);
        }
      }
    } catch (err) {
      return false;
    }
  };

  const handleClickRemoveImage = () => {
    setProductImage(null);
    setProductImage1(null);
    setUploadedImage(null);
    //setProdImage(dataURLtoFile(default_prod2, "default_prod2.jpg"));
    fileInputRef.current.value = "";
  };

  const handleChangeBrand = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setBrand(selectedOption);
        const selected_id = selectedOption.value;
        setbrand_id(selected_id);

        const resp1 = GetParentCategoryById(selected_id, userID, userToken);
        resp1
          .then(function (result) {
            setBrandInfo(result.data[0]);
            setName(result.data[0].name);
            setNote(result.data[0].note || "");
            setProductImage(result.data[0].profile);
            setProductImage1(result.data[0].cdn_url);
            setFeatrd(result.data[0].featured);
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        setBrandInfo(null);
        setbrand_id("");
        setBrand(selectedOption.label);
      }
    } catch (err) {}
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (userID && userToken) {
        GetAllParentCategories(userID, userToken)
          .then((resp) => {
            setBrands(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [userID, userToken]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    const fetchStoreOptions = async () => {
      const fetchedStoreOptions = getbrands.map((item) => ({
        label: `${item.name}`,
        value: item.category_p_id,
      }));
      setbrandOptions(fetchedStoreOptions);
    };

    fetchStoreOptions();
  }, [getbrands]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header
        title={
          mode === "Add"
            ? "ADD PARENT CATEGORY"
            : mode === "Edit"
            ? "EDIT PARENT CATEGORY"
            : "DELETE PARENT CATEGORY"
        }
      />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row
            xs={1}
            sm={1}
            className="justify-content-center"
            style={{ padding: "0" }}
          >
            <Col md={2} className="container-col" />
            <Col md={4} className="container-col">
              {(mode === "Edit" || mode === "Delete") && (
                <>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="label">Parent Category List:</label>
                      <Select
                        className="myreact-select container-select"
                        value={brand}
                        onChange={handleChangeBrand}
                        options={brandOptions}
                        isSearchable
                        placeholder="Select a Parent Category"
                      />
                      {ValError[0] && (
                        <p className="label-error-select">{ValError[0]}</p>
                      )}
                    </div>
                  </div>
                  <br />
                  <br />
                </>
              )}
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Name:</label>
                  <input
                    type="text"
                    name="pcat_name"
                    value={name}
                    onChange={handleChangeName}
                    className="input"
                    placeholder="Parent Category Name"
                    onBlur={(e) => validName1(e.target.value, 1)}
                    disabled={mode === "Delete"}
                  />
                  {ValError[1] && <p className="label-error">{ValError[1]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Details:</label>
                  <textarea
                    name="detail"
                    placeholder="Parent Category Details"
                    value={note}
                    onChange={handleChangeNote}
                    className="textarea"
                    onBlur={(e) => ValidText1(e.target.value, 2)}
                    disabled={mode === "Delete"}
                  />
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="Featured"
                  checked={featrd === 1}
                  onChange={handleChangFeatrd}
                  disabled={mode === "Delete"}
                />
                {` `}Featured
              </label>
              <br />
              {defaultImageMode && (
                <>
                  <div className="mt-0 col-lg-12">
                    <div className="form-group">
                      <label className="label">Profile:</label>
                      {ProductImage1 ? (
                        <div className="container-video-div">
                          <img
                            src={`${ProductImage1}`}
                            className="container-image"
                            alt="Img"
                          />
                          <div className="crs-btn pl-2">
                            <button
                              type="button"
                              onClick={handleClickRemoveImage}
                            >
                              ❌
                            </button>
                          </div>
                        </div>
                      ) : uploadedImage ? (
                        <div className="container-video-div">
                          <img
                            src={uploadedImage}
                            className="container-image"
                            alt="Img"
                          />
                          <div className="crs-btn pl-2">
                            <button
                              type="button"
                              onClick={handleClickRemoveImage}
                            >
                              ❌
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="container-video-div"
                          style={{ width: "80%" }}
                        >
                          <img
                            src={default_prod2}
                            className="container-image"
                            alt="Customer"
                          />
                        </div>
                      )}
                      <div className="mt-1 product-image-input">
                        <input
                          ref={fileInputRef}
                          className="flex justify-left"
                          type="file"
                          id="imageInput"
                          accept="image/*"
                          disabled={mode === "Delete"}
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                </>
              )}
              <br />
            </Col>
            <Col md={4} className="container-col">
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Add"
                borderRadius="10px"
                onClick={handleAddMode}
              />
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Edit"
                borderRadius="10px"
                onClick={handleEditMode}
              />
              <Button
                color="white"
                margin="10px"
                padding="20px"
                bgColor={currentColor}
                text="Delete"
                borderRadius="10px"
                onClick={handleDeleteMode}
              />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          color="white"
          margin="10px"
          padding="20px"
          bgColor={currentColor}
          text={
            mode === "Add" ? "ADD NEW" : mode === "Edit" ? "UPDATE" : "REMOVE"
          }
          borderRadius="10px"
          onClick={handleAddSubmit}
          disabled={loadBtn}
        />
        <Button
          color="white"
          margin="10px"
          padding="20px"
          bgColor={currentColor}
          text="BACK"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditParentCategory;
